export interface MembershipType {
  description: string;
  code: string;
}

export type PartnerType = { [key: string]: any };
export const DefaultPartners: PartnerType = {
  CM: 'COPA AIRLINES',
  DL: 'DELTA AIRLINES	',
};

export const getPartners = (associatedPartner: PartnerType) => {
  const partnerDetails: any = [];
  Object.keys(associatedPartner).forEach((x) => {
    partnerDetails.push({ code: x, description: associatedPartner[x] });
  });
  partnerDetails.sort((el1: MembershipType, el2: MembershipType) => {
    if (el1.description.toLocaleLowerCase() > el2.description.toLocaleLowerCase()) return 1;
    if (el1.description.toLocaleLowerCase() < el2.description.toLocaleLowerCase()) return -1;

    return 0;
  });
  return partnerDetails;
};
